import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../../commons/services/http.service';
import { INTERCONEXION_GATEWAY, INTERCONEXION_ICOIJ, INTERCONEXION_METHOD_GETACUSEDEMBYFOLIO } from '../../../app-module.token';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseReponseGeneric } from '../../../commons/class/BaseReponseGeneric.interface';
import { AcuseDTO } from '../../../commons/class/Acuse.class';

@Injectable({ providedIn: 'root' })
export class ConsultaDemandaService {

    private httpService: HttpService = inject(HttpService);
    private icoj_gateway = inject(INTERCONEXION_GATEWAY);
    private icoj = inject(INTERCONEXION_ICOIJ);
    private getDemandaByFolio = inject(INTERCONEXION_METHOD_GETACUSEDEMBYFOLIO);

    /**
     * Obtiene la demanda por folio, se construye la ruta para la consulta utilizando el folio de la demanda, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable con un objeto genérico que contiene un AcuseDTO
     * @param folio 
     * @returns 
     */
    getDemandaByfolio(folio: any): Observable<BaseReponseGeneric<AcuseDTO>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.getDemandaByFolio}/${folio}`;
        return this.httpService.getRequest(url, headers) as Observable<BaseReponseGeneric<AcuseDTO>>
    }
}